/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useDeferredValue } from "react";
import { Box } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useAnimatedStreamingText } from "../../hooks/useAnimatedStreamingText";
import { streamingMarkdownTextStyles } from "./StreamingMarkdownTextStyles";

type StreamingMarkdownTextProps = {
  text: string;
  emptyText?: string;
  animated?: boolean;
};

export function StreamingMarkdownText({ text, emptyText = "", animated = true }: StreamingMarkdownTextProps) {
  const visibleText = useAnimatedStreamingText({
    text,
    enabled: animated,
  });

  const deferredText = useDeferredValue(visibleText);

  if (!deferredText) {
    return <>{emptyText}</>;
  }

  return (
    <Box sx={streamingMarkdownTextStyles.root}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{deferredText}</ReactMarkdown>
    </Box>
  );
}
